module.exports = __webpack_public_path__ + "static/media/adipometro2.9471df6b.svg";